import { isLocale, LOCALE_INFO, loadMessages, SOURCE_LOCALE, type Messages } from "@omony/i18n";
import { cx } from "@omony/ui";
import { useEffect, useState, type ReactNode } from "react";
import { IntlProvider, useIntl } from "react-intl";
import styles from "./console.module.css";

/**
 * Patientensprache (ARCHITEKTUR §10.4): eigener IntlProvider mit `lang` und `dir`, damit Patient:innen
 * Einwilligung, Fragebogen und Hinweise in ihrer Sprache lesen, während das Personal in der
 * Oberflächensprache bedient. Mit `badge` wird die Fläche als Patientenbereich gekennzeichnet.
 */
export function PatientLanguage({
  locale,
  children,
  badge = true,
  className,
}: {
  locale: string;
  children: ReactNode;
  badge?: boolean;
  className?: string;
}) {
  const loc = isLocale(locale) ? locale : SOURCE_LOCALE;
  const [messages, setMessages] = useState<Messages | null>(null);
  const staff = useIntl();
  useEffect(() => {
    let alive = true;
    void loadMessages(loc).then((m) => alive && setMessages(m));
    return () => {
      alive = false;
    };
  }, [loc]);
  if (!messages) return null;
  const info = LOCALE_INFO[loc];
  return (
    <section
      className={cx(styles.patientArea, className)}
      lang={loc}
      dir={info.dir}
      aria-label={staff.formatMessage({ id: "console.patientArea" })}
    >
      {badge ? (
        <span className={styles.langBadge} lang={loc}>
          {info.endonym}
        </span>
      ) : null}
      <IntlProvider locale={loc} messages={messages} defaultLocale={SOURCE_LOCALE}>
        {children}
      </IntlProvider>
    </section>
  );
}
